import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-2/5 order-2 lg:order-1">
            <div className="relative">
              <div className="w-full aspect-[4/5] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20beautifully%20organized%20workspace%20with%20a%20laptop%20displaying%20a%20spreadsheet%2C%20surrounded%20by%20fashion%20magazines%20and%20style%20accessories%20on%20a%20minimal%20desk%2C%20warm%20natural%20lighting%20from%20a%20nearby%20window%2C%20soft%20cream%20and%20beige%20tones%2C%20editorial%20photography%2C%20clean%20aesthetic&width=800&height=1000&seq=about-main-2026&orientation=portrait"
                  alt="CSSBuy Spreadsheet workspace guide"
                  className="w-full h-full object-cover object-top"
                  title="CSSBuy Spreadsheet Guide - Organized Workspace"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 md:w-40 md:h-40 rounded-xl overflow-hidden bg-background-200 border-4 border-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20closeup%20of%20a%20stylish%20sneaker%20and%20shopping%20bag%20on%20a%20clean%20minimal%20cream%20surface%2C%20soft%20diffused%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20simple%20composition&width=400&height=400&seq=about-thumb-2026&orientation=squarish"
                  alt="CSSBuy shopping product detail"
                  className="w-full h-full object-cover object-center"
                  title="CSSBuy Spreadsheet Product Detail"
                />
              </div>
            </div>
          </div>

          <div className="w-full lg:w-3/5 order-1 lg:order-2">
            <span className="inline-block px-3 py-1 rounded-full border border-foreground-200 text-foreground-500 font-label text-xs tracking-wide uppercase mb-4">
              Trusted Guide
            </span>
            <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-2">
              CSSBuy Sheet
            </h2>
            <h3 className="font-heading font-medium text-2xl md:text-3xl text-foreground-400 mb-8">
              Shopping Guide
            </h3>

            <div className="space-y-5 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                Navigating the world of Chinese shopping agents can be overwhelming. That is why we built the <strong className="text-foreground-900">ultimate CSSBuy spreadsheet hub</strong> — a meticulously organized collection of product links, trusted seller directories, and shopping guides designed to make your CSSBuy experience seamless and efficient.
              </p>
              <p>
                Whether you are hunting for <strong className="text-foreground-900">rare sneakers</strong>, <strong className="text-foreground-900">limited-edition streetwear</strong>, or <strong className="text-foreground-900">designer accessories</strong>, our spreadsheets connect you directly to verified sellers across every major category. Each entry is hand-curated and regularly updated to ensure accuracy and reliability.
              </p>
              <p>
                Our CSSBuy sheet collection covers <strong className="text-foreground-900">14 product categories</strong> with thousands of individually vetted product links. From <strong className="text-foreground-900">shoes and hoodies</strong> to <strong className="text-foreground-900">perfumes and accessories</strong>, every spreadsheet is structured for fast browsing and confident purchasing. Stop wasting hours searching scattered forums — your complete CSSBuy spreadsheet resource starts right here.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <Link
                to="/cssbuy-sheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 border-b-2 border-primary-500 text-foreground-900 font-label font-semibold text-sm hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Full CSSBuy Sheet Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 text-foreground-500 font-label font-medium text-sm hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Visit Main Site
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>

            <div className="flex flex-wrap gap-6 md:gap-10 mt-10 pt-8 border-t border-background-200/70">
              <div>
                <span className="font-heading font-bold text-3xl md:text-4xl text-primary-500">14+</span>
                <p className="text-xs text-foreground-400 mt-1">Categories</p>
              </div>
              <div>
                <span className="font-heading font-bold text-3xl md:text-4xl text-primary-500">10K+</span>
                <p className="text-xs text-foreground-400 mt-1">Products</p>
              </div>
              <div>
                <span className="font-heading font-bold text-3xl md:text-4xl text-primary-500">100+</span>
                <p className="text-xs text-foreground-400 mt-1">Sellers</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}